// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"23dcd4ca","619":"cdfa5797","670":"89872020","801":"23dcd4ca"}[chunkId] + ".chunk.css";
};